import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintWorkflow } from './';

/**
 * @component {kat-blueprint-workflow-action} KatBlueprintWorkflowAction Component used to place and filter components within the action section.
 * @slot default Blueprint content for action section.
 */
@register(KatBlueprintWorkflow.slotMapping.action.name)
export class KatBlueprintWorkflowAction extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintWorkflow.slotMapping.action.name,
      KatBlueprintWorkflow.slotMapping.action.allowed
    );
  }
}
